import * as React from 'react'

import spinnerIcon from '../../../misc/images/icons/spinner.svg'
import styles from './Loading.module.scss'

export const Loading = () => <img className={styles.spinnerIcon} src={spinnerIcon} alt={'loading'} />
